import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true
})
export class SortByPipe implements PipeTransform {
  transform<T>(value: T[], field?: string): T[] {
    if (!value || !Array.isArray(value) || value.length <= 1) {
      return value;
    }

    const sorted = [...value];

    if (field) {
      return sorted.sort((a, b) => {
        const aVal = (a as any)[field];
        const bVal = (b as any)[field];
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return aVal.localeCompare(bVal);
        }
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return aVal - bVal;
        }
        return String(aVal ?? '').localeCompare(String(bVal ?? ''));
      });
    }

    return sorted.sort((a, b) => String(a).localeCompare(String(b)));
  }
}
